import LegalPage from './LegalPage';

const PrivacyPolicyPage = () => (
  <LegalPage
    slug="privacy-policy"
    canonical="/privacy_policy"
    fallbackTitle="Privacy Policy"
    fallbackDescription="How UniXperts collects, uses and protects your information."
  />
);

export default PrivacyPolicyPage;
